import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { GBAddressCountry, USAddressCountry } from '../../../../api/models'
import { MISSING_VALUE } from '../../../../constants'

function shouldShowInternational(digits: string, country: USAddressCountry | GBAddressCountry) {
  if (country === USAddressCountry.US) return digits.length === 11 && digits.startsWith('1')
  if (country === GBAddressCountry.GB) return digits.startsWith('44')
  return false
}

export function formatPhoneNumberForDisplay(phoneNumber: string, country: USAddressCountry | GBAddressCountry) {
  const clean = (phoneNumber ?? '').replace(/\D/g, '')
  if (!clean) return MISSING_VALUE.repeat(3)

  const region = country === GBAddressCountry.GB ? 'GB' : 'US'
  const phone = parsePhoneNumberFromString(clean, region)
  if (!phone) return clean

  return shouldShowInternational(clean, country) ? phone.formatInternational() : phone.formatNational()
}
